import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Check = function Check(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78711 21.9014C10.4316 21.9014 10.9365 21.6436 11.291 21.1172L21.3457 5.60547C21.6035 5.21875 21.7109 4.86426 21.7109 4.53125C21.7109 3.65039 21.0664 3.0166 20.1641 3.0166C19.541 3.0166 19.165 3.23145 18.7891 3.83301L9.74414 18.1416L5.125 12.3193C4.75977 11.8789 4.38379 11.6748 3.84668 11.6748C2.93359 11.6748 2.27832 12.3193 2.27832 13.2109C2.27832 13.5977 2.40723 13.9629 2.74023 14.3496L8.29395 21.1709C8.71289 21.6758 9.1748 21.9014 9.78711 21.9014Z"
  })));
};

Check.displayName = 'Check';
export default Check;